<template>
    <v-row no-gutters>
        <v-col cols="9">
            <v-card flat>
                <v-container fluid class="pl-0 pb-0">
                    <v-row no-gutters>
                        <v-col cols="4" class="pr-6">
                            <select_reporter :selected_reporter="reportedby" field="reportedby" :isClearable="true" @updateData="updateData" />
                        </v-col>
                        <v-col cols="4" class="">
                            <select_gebr :selected_gebr="hosm_gebr" field="hosm_gebr" label="Assigned to" :isClearable="true" @updateData="updateData" />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field :value="claim_ins" label="Claim number insurer" dense class="px-6" v-on:input="updateClaimIns"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="pr-6">
                            <select_incidenttype :selected_incidenttypes="hosm_smct_sel" :visibleChips="4" field="hosm_smct_sel" :isClearable="true" @updateData="updateData" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>
        <v-col cols="3">
            <v-card flat>
                <v-container fluid class="pl-0 pb-0 pt-4">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-checkbox v-model="customerIsInformed" label="Customer is informed" color="primary" dense hide-details v-on:change="updateCustomerInformed"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-checkbox v-model="customerHeldLiable" label="Customer is held liable" color="primary" dense hide-details v-on:change="updateCustomerLiable"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-checkbox v-model="depositIsPaid" label="Deposit is paid" color="primary" dense hide-details v-on:change="updateDepositPaid"></v-checkbox></v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import select_reporter from '@/components/huov/ui/select_reporter.vue'    
import select_incidenttype from '@/components/huov/hosm/ui/select_incidenttype.vue'

export default {
    props: {
        hosm_gebr:{
            type: String,
            default: ''
        } ,
        reportedby: {
            type: String,
            default: ''
        },
        claim_ins:{
            type: String,
            default: ''
        },
        hosm_smct_sel:{
            type: Array,
            default: function() { return []; },
        },
        customerInformed:{
            type: Boolean,
            default: false
        },
        customerLiable:{
            type: Boolean,
            default: false
        },
        depositPaid:{
            type: Boolean,
            default: false
        }
    },
    components: {
        select_gebr,
        select_reporter,      
        select_incidenttype        
    },
    data() {
        return {          
            customerHeldLiable: this.customerLiable,   
            depositIsPaid: this.depositPaid,   
            customerIsInformed: this.customerInformed,   
        }
    },   
    methods: {
        updateData(data){
            console.log('component: updateData');
            this.$emit('updateData', data);
        },	        
        updateClaimIns(data){
            this.$emit('updateData', {field: 'claim_ins', value: data});
        },
        updateCustomerInformed(data){
            this.$emit('updateData', {field: 'customerInformed', value: data});
        },
        updateCustomerLiable(data){
            this.$emit('updateData', {field: 'customerLiable', value: data});
        },
        updateDepositPaid(data){
            this.$emit('updateData', {field: 'depositPaid', value: data});
        },

    }    
}    
</script>

<style scoped>
</style>